module.exports = __webpack_public_path__ + "media/old_images/default-site-area-180cdf93.png";